import React from 'react';
import { useTranslation } from 'react-i18next';

import { IconPanel } from '../../../icon-panel/icon-panel';
import {
  IntegrationAsbuiltStatus,
  IntegrationsContext,
} from '../../../integrations/state/integrations-state';
import { AsbuiltContent } from './asbuilt-content';

const AsbuiltPanelState = () => {
  const { t } = useTranslation();
  const { integrationAsbuiltSupportState } = React.useContext(IntegrationsContext);

  const resolveInformationText = (integrationsStatus: IntegrationAsbuiltStatus) => {
    if (integrationsStatus === IntegrationAsbuiltStatus.NotSupported) {
      return {
        title: t('asBuiltSupportMissing.title', { ns: 'skyviewAsbuilt' }),
        info: t('asBuiltSupportMissing.text', { ns: 'skyviewAsbuilt' }),
      };
    }
    if (integrationsStatus === IntegrationAsbuiltStatus.NoIntegrations) {
      return {
        title: t('noActiveIntegrations.title', { ns: 'skyviewAsbuilt' }),
        info: t('noActiveIntegrations.text', { ns: 'skyviewAsbuilt' }),
      };
    }
  };

  switch (integrationAsbuiltSupportState()) {
    case IntegrationAsbuiltStatus.Supported:
      return <AsbuiltContent />;
    case IntegrationAsbuiltStatus.NotSupported:
    case IntegrationAsbuiltStatus.NoIntegrations:
      return (
        <IconPanel
          header={{ icon: { icon: ['fad', 'chart-network'], opacity: '50%', size: '10x' } }}
          responsiveness={{ componentPxHeightBreak: 356 }}
        >
          {resolveInformationText(integrationAsbuiltSupportState())!}
        </IconPanel>
      );
  }
};

export { AsbuiltPanelState };
